export default __webpack_public_path__ + "static/media/coin.da06a356.png";